import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'submitButton']

  connect () {
    this.inputTargets.forEach(() => {
      this.toggleSubmitButtonState()
    })

    this.inputTargets.forEach(input => {
      input.addEventListener('input', this.toggleSubmitButtonState.bind(this))
    })
  }

  toggleSubmitButtonState () {
    const allFilled = this.inputTargets.every(input => input.value.trim() !== '')
    this.submitButtonTarget.disabled = !allFilled
  }
}
